<div class="flex justify-center">
  <span class="r1-icon" [ngClass]="value === 'Yes' ? 'r1-icon-check-light' : 'r1-icon-remove-light'"></span>
</div>
